import { useEffect, useState } from 'react';
import s from './AddCourseModule.module.scss';
import ImageIcon from "../../../../../../../../assets/icons/image.svg"
import { StyledHTMLFieldsBlock } from 'components/StyledHTMLFiledsBlock/StyledHTMLFieldsBlock';
import { FileManager } from 'components/FileManager/FileManager';
import { useSelector } from 'react-redux';
import { ModalGeneral } from 'components/Modals/ModalGeneral';
import { useTranslation } from 'react-i18next';
import questionMark from "assets/images/questionMark.webp";
import { ImageInput } from 'components/ImageInput/ImageInput';

export const AddCourseModule = ({form, setForm, currentModule, activeLang, setActiveLang, module, setMode, setCurrentLesson, setModules, setCurrentModule, setDeletedModules}: any) => {

    // ### State
    const langs = useSelector((store: any) => store.main.langs);

    const initialLessonState = {
        new: true,
        video: undefined,
        preview: undefined,
        name: langs?.reduce((acc: any, lang: any) => {
            acc[lang.key] = ""
            return acc
        }, {}),
        description: langs?.reduce((acc: any, lang: any) => {
            acc[lang.key] = ""
            return acc
        }, {}),
        links: []
    }

    const [showDeleteModal, setShowDeleteModal] = useState<any>(false);

    const {t} = useTranslation()

    // ### Effects

    // ### Functions

    function changeModuleText(key: any, value: any){
        console.log("value", value);
        setForm((prev: any) => {
            return {
                ...prev,
                modules: prev.modules?.map((mod: any) => {
                    if(mod.id === currentModule.id){
                        return {
                            ...mod,
                            [key]: {...mod[key], ...value}
                        }
                    } else return mod
                })
            }
        })
    }

    function addNewLesson(){
        const now = Number(new Date().getTime().toString().slice(-5))
        
        setCurrentLesson({id: now}); 
        setMode("lesson"); 
        setModules((prev: any) => ({...prev, [module.id]: true}))
        setForm((prev: any) => {
            return {
                ...prev,
                modules: prev.modules?.map((mod: any) => {
                    if(mod.id === currentModule.id){
                        return {
                            ...mod,
                            lessons: mod?.lessons ? [
                                ...mod?.lessons,
                                {
                                    id: now,
                                    ...initialLessonState
                                }
                            ]:[
                                {
                                    id: now,
                                    ...initialLessonState
                                }
                            ]
                        }
                    } else return mod
                })
            }
        })
    }

    function deleteModule(id: number){
        setForm((prev: any) => ({
            ...prev,
            modules: prev.modules?.filter((mod: any) => mod.id !== id)
        }))
        setCurrentModule(form?.modules?.[0])

        setDeletedModules((prev: any) => {
            return [...prev, id]
        })
    }

    // ### Views

    return(
        <div className={s.module_wrapper}>
            <div className={s.buttons_wrapper}>
                <div 
                    className={s.add_button} 
                    onClick={addNewLesson}
                >{t('courses.add_lesson')}</div>
            </div>

            <div className={s.buttons_delete_wrapper}>
                <div 
                    className={s.add_button} 
                    onClick={()=>setShowDeleteModal(currentModule?.id)}
                >{t('courses.delete_module')}</div>
            </div>
            
            <div className={s.image_wrapper}>
                <ImageInput 
                    values={form?.modules?.find((mod: any) => mod.id === currentModule.id)?.image}
                    setValues={(value: any) => {
                        setForm((prev: any) => ({
                            ...prev,
                            modules: prev.modules?.map((mod: any) => {
                                if(mod.id === currentModule.id){
                                    return {
                                        ...mod,
                                        image: {
                                            ...mod.image,
                                            ...value
                                        }
                                    }
                                } 
                                else return mod
                            })
                        }))
                    }}
                    setIsManual={(value: any) => {
                        setForm((prev: any) => ({
                            ...prev,
                            modules: prev.modules?.map((mod: any) => {
                                if(mod.id === currentModule.id){
                                    return {
                                        ...mod,
                                        image: {
                                            ...mod.image,
                                            isManual: value
                                        }
                                    }
                                } 
                                else return mod
                            })
                        }))
                    }}
                    setDefault={(value: any) => {
                        setForm((prev: any) => ({
                            ...prev,
                            modules: prev.modules?.map((mod: any) => {
                                if(mod.id === currentModule.id){
                                    return {
                                        ...mod,
                                        image: {
                                            ...mod.image,
                                            default_image: value
                                        }
                                    }
                                } 
                                else return mod
                            })
                        }))
                    }}
                />
            </div>
            <div className={s.item}>
                <StyledHTMLFieldsBlock 
                    title={t('courses.module_name')} 
                    values={form.modules?.find((mod: any) => mod.id === currentModule?.id)?.name } 
                    changeValue={val => changeModuleText("name", val)} 
                    setLang={() => {}} 
                    activeLang={activeLang}
                    setActiveLang={setActiveLang}
                    height={150}
                />
            </div>
            <div className={s.item}>
                <StyledHTMLFieldsBlock 
                    title={t('courses.module_description')} 
                    values={form.modules?.find((mod: any) => mod.id === currentModule?.id)?.description }
                    changeValue={val => changeModuleText("description", val)}
                    setLang={() => {}} 
                    activeLang={activeLang}
                    setActiveLang={setActiveLang}
                    height={200}
                />
            </div>

            <ModalGeneral
                showModal={showDeleteModal}
                setShowModal={setShowDeleteModal}
                title={t("general.delete")}
                textLeftButton={t("general.cancel")}
                textRightButton={t("general.delete")}
                image={questionMark}
                description={`${t("general.areYouSure")}? ${t("general.itsContents")}`}
                buttonRight={() => deleteModule(showDeleteModal)}
            />
        </div>
    )
}